import React from 'react'
import spinner from '../../assets/giffs/spinner.gif'

const Spinner = () => {
  return (
    <div><img src={spinner} alt="Spinner" className='Spinner' /></div>
  )
}

export default Spinner